import React, { useState, useEffect, useRef } from 'react';

const TypewriterLine = ({ text, speed = 50, onComplete }) => {
  const [displayedText, setDisplayedText] = useState('');
  const indexRef = useRef(0);

  useEffect(() => {
    const typeCharacter = () => {
      if (indexRef.current < text.length) {
        // Metnin tamamını, ilk indexRef.current+1 karakter olarak set ediyoruz.
        setDisplayedText(text.slice(0, indexRef.current + 1));
        indexRef.current++;
        setTimeout(typeCharacter, speed);
      } else {
        if (onComplete) onComplete();
      }
    };

    typeCharacter();

    // Cleanup yapılabilir ama burada süreklilik isteniyor
  }, [text, speed, onComplete]);

  return <p className="typewriter-line">{displayedText}</p>;
};

export default TypewriterLine;
